export { default } from './SectionTrucking';